'use client';

import React from 'react';
import { Bell, Settings, Menu } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Badge } from '@/components/ui/badge';

interface HeaderProps {
  onToggleSidebar?: () => void;
}

export function Header({ onToggleSidebar }: HeaderProps) {
  return (
    <header className="border-b bg-white px-3 sm:px-6 py-3 sm:py-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2 sm:gap-4 min-w-0">
          <Button variant="ghost" size="icon" onClick={onToggleSidebar} className="lg:hidden flex-shrink-0">
            <Menu className="h-5 w-5" />
          </Button>
          <h1 className="text-base sm:text-xl font-semibold whitespace-nowrap">HRTech Pro</h1>
          <Badge variant="secondary" className="text-[10px] sm:text-xs hidden sm:inline-flex whitespace-nowrap">직무급 설계</Badge>
        </div>

        <div className="flex items-center gap-1 sm:gap-4">
          <Button variant="ghost" size="icon" className="relative h-8 w-8 sm:h-10 sm:w-10">
            <Bell className="h-4 w-4 sm:h-5 sm:w-5" />
            <Badge className="absolute -top-0.5 -right-0.5 h-4 w-4 sm:h-5 sm:w-5 flex items-center justify-center text-[10px] p-0">
              3
            </Badge>
          </Button>

          <Button variant="ghost" size="icon" className="h-8 w-8 sm:h-10 sm:w-10 hidden sm:inline-flex">
            <Settings className="h-4 w-4 sm:h-5 sm:w-5" />
          </Button>

          <div className="flex items-center gap-2">
            <Avatar className="h-8 w-8 sm:h-10 sm:w-10">
              <AvatarImage src="" alt="Profile" />
              <AvatarFallback className="bg-blue-100 text-blue-600 text-xs sm:text-sm">김</AvatarFallback>
            </Avatar>
            <div className="text-sm hidden md:block">
              <div className="font-medium text-xs sm:text-sm">김인사 팀장</div>
              <div className="text-gray-500 text-xs">인사부</div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
